import { createApp } from 'vue'
import './bootstrap'
import App from './components/App.vue'
import router from './router'
import PrimeVue from 'primevue/config'
import FloatingVue from 'floating-vue'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import print from 'vue3-print-nb'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faChartSimple,
  faTruck,
  faBoxOpen,
  faChartLine,
  faGears,
  faAddressBook,
  faPrint,
  faTruckFront,
  faCommentDollar,
  faAngleLeft,
  faAnglesLeft,
  faChevronCircleLeft,
  faChevronCircleRight,
  faAnglesRight,
  faQuestion,
  faTrashCan,
  faPencil,
  faFlag,
  faFileArrowUp,
  faInfoCircle,
  faCaretUp,
  faCaretDown,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faChartSimple,
  faTruck,
  faBoxOpen,
  faChartLine,
  faGears,
  faAddressBook,
  faPrint,
  faCommentDollar,
  faTruckFront,
  faAngleLeft,
  faAnglesLeft,
  faAnglesRight,
  faChevronCircleLeft,
  faChevronCircleRight,
  faQuestion,
  faTrashCan,
  faPencil,
  faFlag,
  faFileArrowUp,
  faInfoCircle,
  faCaretUp,
  faCaretDown,
)

router.beforeEach((to, from, next) => {
  document.title = 'RMS - ' + to.name
  next()
})

createApp(App)
  .component('font-awesome-icon', FontAwesomeIcon)
  .use(PrimeVue)
  .use(ToastService)
  .use(ConfirmationService)
  .use(print)
  .use(FloatingVue)
  .use(router)
  .mount('#vueApp')
